import { apiClient } from './index';
import { ApiResponse } from '@/types';

export interface SiteConfig {
  base_url: string;
  timers: {
    cart_minutes: number;
    order_minutes: number;
    payment_halyk_minutes: number;
    payment_manual_hours: number;
  };
  orders: {
    minimum_order_amount: number;
    is_minimum_order_enabled: boolean;
    delivery_time_slots: Array<{ value: string; label: string }>;
  };
  // ✅ ДОБАВИТЬ: Настройки доставки
  delivery: {
    free_delivery_threshold: number;
    is_free_delivery_enabled: boolean;
    delivery_fee: number;  // Стандартная стоимость доставки (1500)
  };

  working: {
    mode: '24_7' | 'scheduled';
    hours_ru: string;
    hours_kz: string;
    hours_en: string;
  };
  contacts: {
    order_phone: string;
    contact_phone: string;
    contact_email: string;
    facebook_url: string;
    instagram_url: string;
    threads_url: string;
    tiktok_url: string;
  };
  legal: {
    delivery_terms_ru: string;
    delivery_terms_kz: string;
    delivery_terms_en: string;
    payment_terms_ru: string;
    payment_terms_kz: string;
    payment_terms_en: string;
    how_to_order_ru: string;
    how_to_order_kz: string;
    how_to_order_en: string;
    privacy_policy_ru: string;
    privacy_policy_kz: string;
    privacy_policy_en: string;
    terms_of_use_ru: string;
    terms_of_use_kz: string;
    terms_of_use_en: string;
    ambassador_offer_ru: string;
    ambassador_offer_kz: string;
    ambassador_offer_en: string;
  };
  // ✅ ДОБАВЛЕНО: Настройки отзывов
  feedback: {
    enabled: boolean;
    delay_hours: number;
    reminder_hours: number;
    max_attempts: number;
    auto_approve_high_ratings: boolean;
  };
}

export interface SiteConfigUpdate {
  // Таймеры
  cart_timer_minutes?: number;
  order_timer_minutes?: number;
  payment_halyk_timer_minutes?: number;
  payment_manual_timer_hours?: number;
  
  // Заказы
  minimum_order_amount?: number;
  is_minimum_order_enabled?: boolean;
  delivery_time_slots?: Array<{ value: string; label: string }>;

  // ✅ ДОБАВИТЬ: Настройки доставки
  free_delivery_threshold?: number;
  is_free_delivery_enabled?: boolean;
  
  // Режим работы
  working_mode?: '24_7' | 'scheduled';
  working_hours_ru?: string;
  working_hours_kz?: string;
  working_hours_en?: string;
  
  // Контакты
  order_phone?: string;
  contact_phone?: string;
  contact_email?: string;
  facebook_url?: string;
  instagram_url?: string;
  threads_url?: string;
  tiktok_url?: string;
  
  // Юридические тексты
  delivery_terms_ru?: string;
  delivery_terms_kz?: string;
  delivery_terms_en?: string;
  payment_terms_ru?: string;
  payment_terms_kz?: string;
  payment_terms_en?: string;
  how_to_order_ru?: string;
  how_to_order_kz?: string;
  how_to_order_en?: string;
  privacy_policy_ru?: string;
  privacy_policy_kz?: string;
  privacy_policy_en?: string;
  terms_of_use_ru?: string;
  terms_of_use_kz?: string;
  terms_of_use_en?: string;

  // ✨ НОВЫЕ ПОЛЯ ДЛЯ ОФЕРТЫ
  ambassador_offer_ru?: string; 
  ambassador_offer_kz?: string; 
  ambassador_offer_en?: string; 
  
  // ✅ ДОБАВЛЕНО: Настройки отзывов
  feedback_enabled?: boolean;
  feedback_delay_hours?: number;
  feedback_reminder_hours?: number;
  feedback_max_attempts?: number;
  auto_approve_high_ratings?: boolean;
}

export const siteApi = {
  getConfig: () =>
    apiClient.get<ApiResponse<SiteConfig>>('/api/admin/site/config/'),
    
  updateConfig: (data: SiteConfigUpdate) =>
    apiClient.patch<ApiResponse<SiteConfig>>('/api/admin/site/config/', data),
};